import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-pdf-dialog',
  templateUrl: './pdf-dialog.component.html',
  styleUrl: './pdf-dialog.component.css'
})
export class PdfDialogComponent {
  pdfSrc: SafeResourceUrl;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer
  ) {
    // Sanitize the URL to mark it as safe
    this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(data.pdfSrc);
  }
}
